import { motion } from 'framer-motion';
import Button from '../../UI/Button';

// Product-specific testimonial content for Sarah
const testimonialContent = {
  nad: {
    quote: "My chronic fatigue is gone. For the first time in years, I'm not exhausted by 3pm, and I'm 52!",
    highlight1: "is gone",
    highlight2: "exhausted by 3pm",
    result: "regained her energy and vitality",
    timeframe: "3 months"
  },
  glutathione: {
    quote: "My skin is glowing like never before. People think I've had work done, but it's just Glutathione!",
    highlight1: "is glowing",
    highlight2: "work done",
    result: "achieved radiant, youthful skin",
    timeframe: "2 months"
  },
  vitaminb12: {
    quote: "I wake up energized and stay focused all day. No more brain fog or afternoon crashes!",
    highlight1: "energized",
    highlight2: "brain fog",
    result: "restored her mental clarity and energy",
    timeframe: "3 weeks"
  },
  lcarnitine: {
    quote: "I've dropped 15 pounds and my workouts are stronger than ever. This is the boost I needed!",
    highlight1: "dropped 15 pounds",
    highlight2: "stronger than ever",
    result: "enhanced her performance and metabolism",
    timeframe: "3 months"
  }
};

export default function TestimonialScreen1({ product, onContinue, onBack }) {
  const content = testimonialContent[product?.id] || testimonialContent.nad;

  // Split quote to highlight specific parts
  const quoteText = content.quote;
  const parts = quoteText.split(new RegExp(`(${content.highlight1}|${content.highlight2})`, 'gi'));

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="max-w-2xl mx-auto"
    >
      <div className="bg-white rounded-luxury shadow-luxury p-8">
        {/* Quote */}
        <h2 className="text-2xl md:text-3xl font-bold text-charcoal text-center mb-8 leading-relaxed">
          "{parts.map((part, index) => {
            const isHighlight = part.toLowerCase() === content.highlight1.toLowerCase() ||
                              part.toLowerCase() === content.highlight2.toLowerCase();
            return isHighlight ? (
              <span key={index} className="text-renuvia-gold">{part}</span>
            ) : (
              <span key={index}>{part}</span>
            );
          })}"
        </h2>

        {/* Image */}
        <div className="mb-8">
          <div className="relative w-full aspect-[4/3] bg-gradient-to-br from-warm-beige to-gray-100 rounded-xl overflow-hidden">
            <img
              src="/images/boosters/woman-jogging.jpg"
              alt="Woman jogging - outdoor lifestyle photo"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>

        {/* Caption */}
        <p className="text-center text-charcoal text-lg mb-8">
          Sarah <strong>{content.result}</strong> in just <span className="text-renuvia-gold font-bold">{content.timeframe}</span>.
        </p>

        <div className="flex gap-4">
          <Button onClick={onBack} variant="ghost" className="w-1/4">
            ←
          </Button>
          <Button onClick={onContinue} variant="primary" className="w-3/4">
            Next →
          </Button>
        </div>
      </div>
    </motion.div>
  );
}
